<hpf-gallery-form
        [gallery]="gallery"
        [loading]="gallery.isNew()"
        (update)="onUpdate()"
        (delete)="onDelete()"
    ></hpf-gallery-form>
<div class="container">
</div>
